// Uzavřený seznam gramatických kategorií nabízených v adminu.
// Zrcadlí LANGUAGE_MECHANISMS v backendu
// (english_teacher_service/app/core/config.py) — když se seznam změní tam,
// je potřeba ho upravit i tady, aby admin nabízel stejné hodnoty.
export const GRAMMAR_CATEGORIES = [
  'Syntax',
  'Affirmatives',
  'Negatives',
  'Interrogatives',
  'Conjugation',
  'Plurals',
  'Articles',
  'Possessives',
  'Agreement',
  'Present',
  'Auxiliaries',
  'Modals',
  'Prepositions',
  'Connectors',
  'Past',
];
